export const MAILCHIMP_IMPORT_BETA = 'mailchimpImport'
export const MAILCHIMP_APP_ID = 10

/** AccountBeta `mailchimpImport`. The import flow is open without this; the account menu still shows Import when it is on. */
export function isMailchimpImportBeta(accountMasterOrState) {
    const am =
        accountMasterOrState?.accountMaster?.beta !== undefined
            ? accountMasterOrState.accountMaster
            : accountMasterOrState?.beta !== undefined
                ? accountMasterOrState
                : accountMasterOrState?.accountMaster
    return Boolean(am?.beta?.[MAILCHIMP_IMPORT_BETA])
}

export function isNewMailchimpApp(app) {
    if (!app) return false
    if (app.options && app.options.mailchimp2) return true
    return app.appName === 'MailChimp 2'
}

export function isLegacyMailchimpApp(app) {
    if (!app || isNewMailchimpApp(app)) return false
    return app.appName === 'MailChimp' || app.appName === 'Mailchimp'
}

/**
 * App 10 is the shared Mailchimp integration. Orphan MailChimp 2 catalog rows are not it.
 * @param {object} app
 * @returns {boolean}
 */
export function isSharedMailchimpApp(app) {
    if (!app || isNewMailchimpApp(app)) return false
    return String(app.id) === String(MAILCHIMP_APP_ID) || isLegacyMailchimpApp(app)
}

/**
 * True when this AccountApplication was created by the new Mailchimp connect.
 * Older rows stay on the previous integration until the account disconnects and connects again.
 * @param {object} accountApp
 * @returns {boolean}
 */
export function usesNewMailchimpConnection(accountApp) {
    const settings = accountApp && accountApp.appSettings
    if (!settings) return false
    // mailchimp2 is set when the connection is created. migrateJob means this row
    // already ran the new import, including connections made before that flag existed.
    return Boolean(settings.mailchimp2 || settings.migrateJob)
}

export function displayMailchimpAppName(app) {
    if (isNewMailchimpApp(app)) return 'Mailchimp'
    return app?.appName
}

/**
 * Hide orphan MailChimp 2 installs so they do not sit beside App 10.
 * @param {object} accountApp
 * @param {boolean} [_betaOn] unused; kept for call-site compatibility
 */
export function isVisibleInstalledApp(accountApp, _betaOn) {
    const app = accountApp && accountApp.Application
    return !isNewMailchimpApp(app)
}

/**
 * Catalog visibility for Mailchimp. App 10 (legacy-named Mailchimp) is the shared
 * integration. Hide orphan MailChimp 2 / options.mailchimp2 rows so they do not
 * appear as a second catalog card.
 * @param {object} app
 * @param {boolean} [_betaOn] unused; kept for call-site compatibility
 */
export function isVisibleCatalogApp(app, _betaOn) {
    return !isNewMailchimpApp(app)
}
